import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-container" }
const _hoisted_2 = { class: "pane1" }
const _hoisted_3 = { class: "pane2" }
const _hoisted_4 = {
  class: "pane3",
  style: {"margin-bottom":"15px"}
}
const _hoisted_5 = { class: "pane4" }
const _hoisted_6 = { class: "pane6" }
const _hoisted_7 = {
  class: "toggle-switch",
  for: "pane6-toggle-1"
}
const _hoisted_8 = {
  class: "toggle-switch",
  for: "pane6-toggle-2"
}
const _hoisted_9 = {
  class: "toggle-switch",
  for: "pane6-toggle-3"
}
const _hoisted_10 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}
const _hoisted_11 = {
  key: 1,
  style: {"margin-bottom":"10px"}
}
const _hoisted_12 = { class: "tab-switch" }
const _hoisted_13 = { for: "status-input-tab-1" }
const _hoisted_14 = { for: "status-input-tab-2" }
const _hoisted_15 = { for: "status-input-tab-3" }
const _hoisted_16 = { class: "enemy" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "enemy-level" }
const _hoisted_19 = {
  key: 2,
  style: {"margin-bottom":"10px"}
}
const _hoisted_20 = { class: "tab-switch" }
const _hoisted_21 = { for: "option-input-tab-1" }
const _hoisted_22 = {
  class: "toggle-switch",
  for: "option-input-tab-2"
}
const _hoisted_23 = { for: "option-input-tab-3" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { style: {"margin-top":"10px"} }
const _hoisted_26 = { class: "result-pane" }
const _hoisted_27 = { class: "pane5" }
const _hoisted_28 = { class: "bottom-pane" }
const _hoisted_29 = {
  class: "toggle-switch no-border",
  for: "own-list-toggle-1"
}
const _hoisted_30 = {
  class: "toggle-switch no-border",
  for: "own-list-toggle-2"
}
const _hoisted_31 = {
  class: "toggle-switch no-border",
  for: "own-list-toggle-3"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "pane7" }
const _hoisted_34 = {
  key: 0,
  id: "debug-info"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { style: {"text-align":"right"} }
const _hoisted_39 = { style: {"text-align":"right"} }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { style: {"text-align":"right"} }
const _hoisted_42 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleAndHeader = _resolveComponent("TitleAndHeader")!
  const _component_CharacterSelect = _resolveComponent("CharacterSelect")!
  const _component_CharacterInput = _resolveComponent("CharacterInput")!
  const _component_CharacterInfo = _resolveComponent("CharacterInfo")!
  const _component_WeaponSelect = _resolveComponent("WeaponSelect")!
  const _component_ArtifactSetSelect = _resolveComponent("ArtifactSetSelect")!
  const _component_ArtifactDetailInput = _resolveComponent("ArtifactDetailInput")!
  const _component_ArtifactScoreFormula = _resolveComponent("ArtifactScoreFormula")!
  const _component_ConditionInput = _resolveComponent("ConditionInput")!
  const _component_StatsInput = _resolveComponent("StatsInput")!
  const _component_NextStat = _resolveComponent("NextStat")!
  const _component_EasyTeamInput = _resolveComponent("EasyTeamInput")!
  const _component_ElementalResonanceInput = _resolveComponent("ElementalResonanceInput")!
  const _component_MiscOptionInput = _resolveComponent("MiscOptionInput")!
  const _component_TeamOptionInput = _resolveComponent("TeamOptionInput")!
  const _component_DamageResult = _resolveComponent("DamageResult")!
  const _component_RotationDamage = _resolveComponent("RotationDamage")!
  const _component_ShareSns = _resolveComponent("ShareSns")!
  const _component_CharacterOwnList = _resolveComponent("CharacterOwnList")!
  const _component_WeaponOwnList = _resolveComponent("WeaponOwnList")!
  const _component_ArtifactOwnList = _resolveComponent("ArtifactOwnList")!
  const _component_AboutMyApp = _resolveComponent("AboutMyApp")!
  const _component_ConfigurationInput = _resolveComponent("ConfigurationInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TitleAndHeader)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CharacterSelect, {
          character: _ctx.characterInputRea.character,
          visible: _ctx.characterSelectVisibleRef,
          "onUpdate:character": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateCharacter($event)))
        }, null, 8, ["character", "visible"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CharacterInput, {
          ref: "characterInputVmRef",
          characterInput: _ctx.characterInputRea,
          "recommendation-list": _ctx.recommendationListRea,
          recommendation: _ctx.recommendationRef,
          "builddata-savable": _ctx.builddataSavable,
          "artifact-set-select-visible": _ctx.artifactSetSelectVisibleRef,
          "artifact-score": _ctx.artifactScore,
          "onOpen:characterSelect": _ctx.openCharacterSelect,
          onSaveToStorage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveToStorage($event))),
          onRemoveFromStorage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeFromStorage($event))),
          "onUpdate:recommendation": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateRecommendation($event))),
          "onOpen:weaponSelect": _ctx.openWeaponSelect,
          "onOpen:artifactSetSelect": _cache[4] || (_cache[4] = ($event: any) => (_ctx.openArtifactSetSelect($event))),
          "onOpen:artifactDetailInput": _ctx.openArtifactDetailInput,
          "onUpdate:characterInputCharacter": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateCharacterInputCharacter($event))),
          "onUpdate:characterInputWeapon": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateCharacterInputWeapon($event))),
          "onOpen:characterInfo": _cache[7] || (_cache[7] = ($event: any) => (_ctx.openCharacterInfo($event)))
        }, null, 8, ["characterInput", "recommendation-list", "recommendation", "builddata-savable", "artifact-set-select-visible", "artifact-score", "onOpen:characterSelect", "onOpen:weaponSelect", "onOpen:artifactDetailInput"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CharacterInfo, {
          visible: _ctx.characterInfoVisibleRef,
          mode: _ctx.characterInfoModeRef,
          "character-master": _ctx.characterInputRea.characterMaster,
          ascension: _ctx.characterInputRea.突破レベル,
          level: _ctx.characterInputRea.レベル,
          "normal-attack-level": _ctx.characterInputRea.通常攻撃レベル,
          "elemental-skill-level": _ctx.characterInputRea.元素スキルレベル,
          "elemental-burst-level": _ctx.characterInputRea.元素爆発レベル,
          "normal-attack-replacing": _ctx.normalAttackReplacing
        }, null, 8, ["visible", "mode", "character-master", "ascension", "level", "normal-attack-level", "elemental-skill-level", "elemental-burst-level", "normal-attack-replacing"]),
        _createVNode(_component_WeaponSelect, {
          visible: _ctx.weaponSelectVisibleRef,
          weapon: _ctx.characterInputRea.weapon,
          "weapon-type": _ctx.weaponType,
          "weapon-master": _ctx.characterInputRea.weaponMaster,
          ascension: _ctx.characterInputRea.武器突破レベル,
          level: _ctx.characterInputRea.武器レベル,
          "onUpdate:weapon": _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateWeapon($event)))
        }, null, 8, ["visible", "weapon", "weapon-type", "weapon-master", "ascension", "level"]),
        _createVNode(_component_ArtifactSetSelect, {
          visible: _ctx.artifactSetSelectVisibleRef,
          index: _ctx.artifactSetIndexRef,
          "artifact-set": _ctx.artifactSets[_ctx.artifactSetIndexRef],
          "artifact-set-masters": _ctx.characterInputRea.artifactSetMasters,
          "onUpdate:artifactSet": _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateArtifactSet($event)))
        }, null, 8, ["visible", "index", "artifact-set", "artifact-set-masters"]),
        _createVNode(_component_ArtifactDetailInput, {
          ref: "artifactDetailInputVmRef",
          visible: _ctx.artifactDetailInputVisibleRef,
          "artifact-detail-input": _ctx.artifactDetailInputRea,
          "is-sub-stat-only": _ctx.isSubStatOnly,
          "next-stat-rows": _ctx.nextStatRows,
          "onUpdate:artifactDetail": _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateArtifactDetail($event)))
        }, null, 8, ["visible", "artifact-detail-input", "is-sub-stat-only", "next-stat-rows"]),
        _createVNode(_component_ArtifactScoreFormula, {
          ref: "artifactScoreFormulaVmRef",
          visible: _ctx.artifactDetailInputVisibleRef,
          "onApply:formula": _ctx.applyArtifactScoreFormula
        }, null, 8, ["visible", "onApply:formula"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "pane6-toggle-1",
            type: "checkbox",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pane6Toggle1Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.pane6Toggle1Ref]
          ]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.displayName('オプション条件')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "pane6-toggle-2",
            type: "checkbox",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pane6Toggle2Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.pane6Toggle2Ref]
          ]),
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.displayName('ステータス')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "pane6-toggle-3",
            type: "checkbox",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pane6Toggle3Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.pane6Toggle3Ref]
          ]),
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.displayName('バフ/デバフ')), 1)
        ]),
        (_ctx.pane6Toggle1Ref)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_ConditionInput, {
                ref: "conditionInputVmRef",
                "character-input": _ctx.characterInputRea,
                "onUpdate:condition": _ctx.updateCondition
              }, null, 8, ["character-input", "onUpdate:condition"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pane6Toggle2Ref)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  id: "status-input-tab-1",
                  type: "radio",
                  value: "1",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.statInputTabRef) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.statInputTabRef]
                ]),
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.displayName('ステータス1')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "status-input-tab-2",
                  type: "radio",
                  value: "2",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.statInputTabRef) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.statInputTabRef]
                ]),
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.displayName('ステータス2')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "status-input-tab-3",
                  type: "radio",
                  value: "3",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.statInputTabRef) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.statInputTabRef]
                ]),
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.displayName('敵')), 1)
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_StatsInput, {
                  "stats-input": _ctx.statsInput,
                  "category1-list": _ctx.CHARACTER_STATS_CATEGORY1_LIST,
                  category2List: _ctx.CHARACTER_STATS_CATEGORY2_LIST,
                  "onUpdate:statAdjustments": _ctx.updateStatAdjustments
                }, null, 8, ["stats-input", "category1-list", "category2List", "onUpdate:statAdjustments"])
              ], 512), [
                [_vShow, _ctx.statInputTabRef == 1]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_StatsInput, {
                  "stats-input": _ctx.statsInput,
                  "category1-list": _ctx.CHARACTER_STATS2_CATEGORY1_LIST,
                  "category2-list": _ctx.CHARACTER_STATS2_CATEGORY2_LIST,
                  "onUpdate:statAdjustments": _ctx.updateStatAdjustments
                }, null, 8, ["stats-input", "category1-list", "category2-list", "onUpdate:statAdjustments"])
              ], 512), [
                [_vShow, _ctx.statInputTabRef == 2]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedEnemyRef) = $event)),
                    onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.updateEnemy && _ctx.updateEnemy(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ENEMY_LIST, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item,
                        key: item.key
                      }, _toDisplayString(_ctx.displayName(item.key)), 9, _hoisted_17))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedEnemyRef]
                  ])
                ]),
                _createElementVNode("label", _hoisted_18, [
                  _cache[29] || (_cache[29] = _createTextVNode("Lv. ")),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.statsInput.statAdjustments['敵レベル']) = $event)),
                    min: "1",
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateStatAdjustments()))
                  }, null, 544), [
                    [_vModelText, _ctx.statsInput.statAdjustments['敵レベル']]
                  ])
                ]),
                _createVNode(_component_StatsInput, {
                  "stats-input": _ctx.statsInput,
                  "category1-list": _ctx.ENEMY_STATS_CATEGORY1_LIST,
                  "category2-list": _ctx.ENEMY_STATS_CATEGORY2_LIST,
                  "onUpdate:statAdjustments": _ctx.updateStatAdjustments
                }, null, 8, ["stats-input", "category1-list", "category2-list", "onUpdate:statAdjustments"])
              ], 512), [
                [_vShow, _ctx.statInputTabRef == 3]
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_NextStat, {
                  ref: "nextStatVmRef",
                  visible: true,
                  "character-input": _ctx.characterInputRea,
                  "artifact-detail-input": _ctx.artifactDetailInputRea,
                  "condition-input": _ctx.conditionInputRea,
                  "option-input": _ctx.optionInputRea,
                  "stats-input": _ctx.statsInput,
                  "damage-result": _ctx.damageResult,
                  "rotation-damage-info": _ctx.rotationDamageInfo,
                  "onUpdate:statAdjustments": _ctx.updateNextStatAdjustments,
                  "onUpdate:nextStatRows": _ctx.updateNextStatRows
                }, null, 8, ["character-input", "artifact-detail-input", "condition-input", "option-input", "stats-input", "damage-result", "rotation-damage-info", "onUpdate:statAdjustments", "onUpdate:nextStatRows"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pane6Toggle3Ref)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  id: "option-input-tab-1",
                  type: "radio",
                  value: "1",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.optionInputTabRef) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.optionInputTabRef]
                ]),
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.displayName('チーム強化')), 1),
                _withDirectives(_createElementVNode("input", {
                  class: "hidden",
                  id: "option-input-tab-2",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.optionInputSupporterRef) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.optionInputSupporterRef]
                ]),
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.displayName('サポーター')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "option-input-tab-3",
                  type: "radio",
                  value: "3",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.optionInputTabRef) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.optionInputTabRef]
                ]),
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.displayName('その他')), 1)
              ]),
              _createVNode(_component_EasyTeamInput, {
                character: _ctx.characterInputRea.character,
                "team-members": _ctx.optionInputRea.teamMembers,
                "onUpdate:teamMembers": _ctx.updateTeamMembers
              }, null, 8, ["character", "team-members", "onUpdate:teamMembers"]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ElementalResonanceInput, {
                  ref: "elementalResonanceInputVmRef",
                  "option-input": _ctx.optionInputRea,
                  character: _ctx.characterInputRea.character,
                  "team-members": _ctx.optionInputRea.teamMembers,
                  "onUpdate:elementalResonance": _ctx.updateElementalResonance
                }, null, 8, ["option-input", "character", "team-members", "onUpdate:elementalResonance"])
              ], 512), [
                [_vShow, _ctx.optionInputTabRef == 1]
              ]),
              (_ctx.optionInputTabRef == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_MiscOptionInput, {
                      ref: "miscOptionInputVmRef",
                      "condition-input": _ctx.optionInputRea.miscOption,
                      "onUpdate:miscOption": _ctx.updateMiscOption
                    }, null, 8, ["condition-input", "onUpdate:miscOption"])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_25, [
                _createVNode(_component_TeamOptionInput, {
                  ref: "teamOptionInputVmRef",
                  visible: true,
                  character: _ctx.characterInputRea.character,
                  "team-members": _ctx.optionInputRea.teamMembers,
                  "condition-input": _ctx.optionInputRea.teamOption,
                  "onUpdate:teamOption": _ctx.updateTeamOption,
                  "onUpdate:buildnameSelection": _ctx.updateBuildnameSelection,
                  "onUpdate:teamMembers": _ctx.updateTeamMembers
                }, null, 8, ["character", "team-members", "condition-input", "onUpdate:teamOption", "onUpdate:buildnameSelection", "onUpdate:teamMembers"])
              ], 512), [
                [_vShow, _ctx.optionInputSupporterRef]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_DamageResult, {
          ref: "damageResultVmRef",
          "damage-result": _ctx.damageResult
        }, null, 8, ["damage-result"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_RotationDamage, {
          "character-master": _ctx.characterInputRea.characterMaster,
          "damage-result": _ctx.damageResult,
          "damage-result2": _ctx.damageResult2,
          "onUpdate:rotationDamage": _ctx.updateRotationDamage
        }, null, 8, ["character-master", "damage-result", "damage-result2", "onUpdate:rotationDamage"]),
        _createVNode(_component_ShareSns, { "onShare:twitter": _ctx.openTwitter }, null, 8, ["onShare:twitter"])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("h2", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "own-list-toggle-1",
            type: "checkbox",
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ownListToggle1Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.ownListToggle1Ref]
          ]),
          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.displayName('キャラクター所持状況')), 1)
        ]),
        (_ctx.ownListToggle1Ref)
          ? (_openBlock(), _createBlock(_component_CharacterOwnList, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("h2", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "own-list-toggle-2",
            type: "checkbox",
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.ownListToggle2Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.ownListToggle2Ref]
          ]),
          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.displayName('武器所持状況')), 1)
        ]),
        (_ctx.ownListToggle2Ref)
          ? (_openBlock(), _createBlock(_component_WeaponOwnList, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("h2", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: "own-list-toggle-3",
            type: "checkbox",
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.ownListToggle3Ref) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.ownListToggle3Ref]
          ]),
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.displayName('聖遺物所持状況')), 1)
        ]),
        (_ctx.ownListToggle3Ref)
          ? (_openBlock(), _createBlock(_component_ArtifactOwnList, { key: 2 }))
          : _createCommentVNode("", true),
        _cache[30] || (_cache[30] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.enableClearLocalStorage) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.enableClearLocalStorage]
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.displayName('ローカルストレージをクリアする')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.clearLocalStorage && _ctx.clearLocalStorage(...args))),
          disabled: !_ctx.enableClearLocalStorage
        }, _toDisplayString(_ctx.displayName('実行')), 9, _hoisted_32),
        _createElementVNode("p", null, _toDisplayString(_ctx.displayName('全ての保存データを削除します')), 1)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_AboutMyApp),
        _createVNode(_component_ConfigurationInput, {
          "configuration-input": _ctx.configurationInputRea,
          "onUpdate:configurationInput": _ctx.updateConfigurationInput,
          "onOrder:initializeArtifactStatsSub": _ctx.orderInitializeArtifactStatsSub
        }, null, 8, ["configuration-input", "onUpdate:configurationInput", "onOrder:initializeArtifactStatsSub"])
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("hr", null, null, -1)),
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "footer" }, [
        _createElementVNode("hr"),
        _createElementVNode("p", null, "© 2021 asagume"),
        _createElementVNode("p", { class: "left" }, " 本サイト内の画像はHoYoverse/COGNOSPHEREの著作物です。 Copyright © COGNOSPHERE. All Rights Reserved. ")
      ], -1))
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
          _cache[34] || (_cache[34] = _createElementVNode("h2", null, "DEBUG", -1)),
          (_ctx.characterInputRea)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.myDamageDatailArr.filter((s) => s), (dd, index) => {
                return (_openBlock(), _createElementBlock("dl", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectKeys(dd), (key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                      (_ctx.getValue(dd, key))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("dt", null, _toDisplayString(key), 1),
                            _createElementVNode("dd", null, [
                              (Array.isArray(_ctx.getValue(dd, key)))
                                ? (_openBlock(), _createElementBlock("ol", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValue(dd, key), (item) => {
                                      return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.getValue(dd, key)), 1))
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
          (_ctx.statsInput)
            ? (_openBlock(), _createElementBlock("table", _hoisted_37, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.statsInput.statsObj), (stat) => {
                    return (_openBlock(), _createElementBlock("tr", { key: stat }, [
                      _createElementVNode("th", _hoisted_38, _toDisplayString(stat), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.statsInput.statsObj[stat]), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
          (_ctx.conditionInput)
            ? (_openBlock(), _createElementBlock("table", _hoisted_40, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.conditionInput.conditionValues), (condition) => {
                    return (_openBlock(), _createElementBlock("tr", { key: condition }, [
                      _createElementVNode("th", _hoisted_41, _toDisplayString(condition), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.conditionInput.conditionValues[condition]), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[37] || (_cache[37] = _createElementVNode("hr", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.HTML_LOGGER), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}